(function () {
  'use strict';

  angular.module('app.communications-analytics.teacher-details', []);

})();
